module.exports = __webpack_public_path__ + "static/media/account_list_event_current.5df680e8.svg";